import { useCallback, useMemo, useState } from 'react';
import { useSideEffectListener } from './useSideEffectListener';
const DECISION_START = 'decisionStart';
const DECISION_CHUNK = 'decisionChunk';
const DECISION_COMPLETED = 'decisionCompleted';
const STREAMING_MODE_APPEND = 'append';
const STREAMING_MODE_OVERRIDE = 'override';
export const useStreaming = _ref => {
  let {
    connection,
    conversationId
  } = _ref;
  const [streamingMessages, setStreamingMessages] = useState([]);
  const onSideEffect = useCallback(payload => {
    const {
      decisionId,
      userMessageId,
      streamingMode
    } = payload;
    const chunkIndex = 'chunkIndex' in payload ? payload.chunkIndex : 'lastChunkIndex' in payload ? payload.lastChunkIndex : -1;
    const accumulatedResponse = 'accumulatedResponse' in payload ? payload.accumulatedResponse : '';
    const isCompleted = 'latestChunkIndex' in payload;
    const newMessage = {
      decisionId,
      isCompleted,
      userMessageId,
      streamingMode,
      accumulatedResponse,
      latestChunkIndex: chunkIndex,
      conversationId: payload.conversationId
    };
    setStreamingMessages(prev => {
      const updatedMessages = [...prev];
      const existingMessageIndex = updatedMessages.findIndex(message => message.decisionId === decisionId);
      if (existingMessageIndex !== -1) {
        const existingMessage = updatedMessages[existingMessageIndex];
        const {
          latestChunkIndex
        } = existingMessage;
        if (chunkIndex > latestChunkIndex || isCompleted) {
          updatedMessages[existingMessageIndex] = {
            ...existingMessage,
            ...newMessage
          };
        }
      } else {
        updatedMessages.push(newMessage);
      }
      return updatedMessages;
    });
  }, []);
  useSideEffectListener({
    connection,
    onSideEffect,
    filter: {
      name: DECISION_START
    }
  });
  useSideEffectListener({
    connection,
    onSideEffect,
    filter: {
      name: DECISION_CHUNK
    }
  });
  useSideEffectListener({
    connection,
    onSideEffect,
    filter: {
      name: DECISION_COMPLETED
    }
  });
  const filteredStreamingMessages = useMemo(() => streamingMessages.filter(message => message.conversationId === conversationId).filter(_ref2 => {
    let {
      accumulatedResponse
    } = _ref2;
    return accumulatedResponse;
  }), [conversationId, streamingMessages]);
  const streamingMessagesByUserMessageId = useMemo(() => {
    const grouped = {};
    for (const message of filteredStreamingMessages) {
      const userMessageId = message.userMessageId ?? 'unknown';
      if (!grouped[userMessageId]) {
        grouped[userMessageId] = [];
      }
      if (message.streamingMode === STREAMING_MODE_APPEND) {
        grouped[userMessageId].push(message.accumulatedResponse);
      } else {
        grouped[userMessageId] = [message.accumulatedResponse];
      }
    }
    return Object.fromEntries(Object.entries(grouped).map(_ref3 => {
      let [userMessageId, responses] = _ref3;
      return [userMessageId, responses.join('\n\n')];
    }));
  }, [filteredStreamingMessages]);
  return {
    streamingMessages: streamingMessagesByUserMessageId
  };
};
//# sourceMappingURL=useStreaming.js.map